// src/services/userAPI.js
import api from './api';


export const updateProfile = async (userId, userData) => {
  try {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    // Rethrow the error to be handled by the component
    throw error.response.data;
  }
};
